import { cn } from '@/lib/utils';

export function ServiceSchedulerHeader({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        'flex flex-col-reverse gap-3 @lg:flex-row @lg:items-center @lg:justify-between @lg:gap-3',
        className,
      )}
    >
      {children}
    </div>
  );
}
